/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { repeatMobileOrderComboModifierSchema } from "./repeatMobileOrderComboModifierSchema.ts";

export const repeatMobileOrderComboGroupModifierSchema = z.object({
	group: z.uuid(),
	modifiers: z.array(repeatMobileOrderComboModifierSchema),
});
